<template>
  <span></span>
</template>
<script>

import swal from 'sweetalert2'
const messages = {
  en: {
    confirmButtonText: 'Continue and delete',
    cancelButtonText: 'Cancel'
  },
  es: {
    confirmButtonText: 'Continuar y borrar',
    cancelButtonText: 'Cancelar'
  }
}
// import { Button, Card } from 'src/components/UIComponents'
export default {
  components: {
    // [Button.name]: Button,
    // Card
  },
  show: function (type = 'warning', title = '', text = '', lang = 'en') {
    if (lang && lang.indexOf('-') !== -1) {
      lang = lang.split('-')[0]
    }
    if (!messages[lang]) {
      lang = 'es' // default
    }
    const { confirmButtonText, cancelButtonText } = messages[lang]
    return swal.fire({
      title,
      text,
      type,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      confirmButtonClass: 'btn btn-danger btn-fill',
      cancelButtonClass: 'btn btn-success btn-fill',
      buttonsStyling: false
    })
  },
  showLoginError: function (text = '') {
    return swal.fire({
      title: '',
      text,
      type: 'warning',
      showCancelButton: false,
      confirmButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false
    })
  },
  showJWTError: function (text = '') {
    return swal.fire({
      title: '',
      text,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'cancel',
      confirmButtonText: 'go to login page',
      confirmButtonClass: 'btn btn-danger btn-fill',
      cancelButtonClass: 'btn btn-warning btn-fill',
      buttonsStyling: false
    })
  }
}
</script>
<style>
.swal2-icon-text {
  font-size: 80px;
}

.swal2-icon.swal2-info, .swal2-icon.swal2-warning {
  font-size: 18px !important;
  /*line-height: 80px;*/
  /*text-align: center;*/
}
</style>
